var map = {
	"./baochang.svg": "9e49",
	"./pad_icon1.svg": "99bb",
	"./pad_icon2.svg": "e6cc",
	"./pad_icon3.svg": "eeac",
	"./pad_icon4.svg": "88d8",
	"./pad_icon5.svg": "39d3",
	"./pad_icon6.svg": "dff8",
	"./pad_icon7.svg": "f787",
	"./pad_icon8.svg": "af2d",
	"./pad_icon9.svg": "b68b",
	"./vipbtn.svg": "c260"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7527";